import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ListaFaltantes } from "./faltan";

type Entity = models.MatrizDistanciasDto;
import { columnas } from "./columns";
const resource = resources.MatrizDistancias;
export class MatrizDistanciasList extends React.PureComponent {
    onBorrar = async (x: Entity) => {
        if (await kea.yesno("¿Borrar elemento de la matriz de distancias?")) {
            await resource.Delete(x.IdRegistro);
        }
    }

    items = observeResource(resource.Query);
    onEdit = (x: Entity) => history.go(`./${x.IdRegistro}`);
    onAgregar = () => history.go('./new');
    onRegresar = () => history.go('../');

    faltantes = observeResource(resource.ParesFaltantes);

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Matriz de distancias" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <ListaFaltantes value={this.faltantes} />
                <kea.Grid2 columnas={cols} cookieKey={"MatrizDistanciaListCookieKey"} items={this.items} />
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/matrizdistancias/list/list.tsx